import { Reveal } from "@/components/pause/motion";

const chapters = [
  {
    no: "01",
    title: "The Breath",
    body: "Every practice begins with the exhale. We slow down first, let the nervous system settle, and let breath lead the body — never the other way around.",
  },
  {
    no: "02",
    title: "The Movement",
    body: "Viniyoga adapts the pose to the person. Function over form, patience over performance — building an agile body that moves with ease at any age.",
  },
  {
    no: "03",
    title: "The Stillness",
    body: "Between the shapes lives the real work: the quiet mind. Meditation and rest are woven through, so you leave lighter than you arrived.",
  },
];

export const About = () => {
  return (
    <section id="about" data-testid="about-section" className="bg-[#1A1A1A] text-[#FAF7F2] py-24 md:py-32">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10">
        <Reveal>
          <img src="/images/logo.png" alt="Pause." data-testid="about-logo" className="h-16 w-16 object-contain mb-6" />
          <p className="font-body text-xs uppercase tracking-[0.28em] text-[#F5C800] mb-8">The Philosophy</p>
        </Reveal>

        <div className="grid grid-cols-1 min-[900px]:grid-cols-12 gap-12 min-[900px]:gap-16 items-start">
          {/* Photo + badge */}
          <div className="min-[900px]:col-span-5">
            <Reveal>
              <div className="relative">
                <div className="overflow-hidden rounded-sm aspect-[4/5]">
                  <img src="/images/photo3.jpg" alt="Nisha looking out at the forest" className="w-full h-full object-cover" />
                </div>
                <div
                  data-testid="years-badge"
                  className="absolute -bottom-8 -right-4 md:-right-8 h-32 w-32 md:h-40 md:w-40 rounded-full bg-[#F5C800] text-[#1A1A1A] flex flex-col items-center justify-center text-center rotate-[-6deg]"
                >
                  <span className="font-display text-4xl md:text-5xl leading-none">10+</span>
                  <span className="font-body text-[10px] uppercase tracking-[0.16em] mt-1">Years of<br />Teaching</span>
                </div>
              </div>
            </Reveal>
          </div>

          {/* Manifesto */}
          <div className="min-[900px]:col-span-7 min-[900px]:pl-8">
            <Reveal>
              <h2 className="font-display font-light text-5xl md:text-7xl leading-[0.95] tracking-tight mb-12">
                A quiet mind. <br />
                <span className="italic text-[#F5C800]">An agile body.</span>
              </h2>
            </Reveal>

            <div className="divide-y divide-[#FAF7F2]/12 border-t border-[#FAF7F2]/12">
              {chapters.map((c, i) => (
                <Reveal key={c.no} delay={i * 0.08}>
                  <div className="grid grid-cols-[auto_1fr] gap-6 md:gap-10 py-8 group">
                    <span className="font-display text-2xl md:text-3xl text-[#8C8070] group-hover:text-[#F5C800] transition-colors duration-500">
                      {c.no}
                    </span>
                    <div>
                      <h3 className="font-display text-2xl md:text-3xl mb-2">{c.title}</h3>
                      <p className="font-body text-[#FAF7F2]/65 leading-relaxed max-w-xl">{c.body}</p>
                    </div>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
